<template>
  <div class="doc">
    <video
      v-if="doc.embed_type === 'video' && isNativeVideo"
      class="embed"
      :src="doc.embed_url"
      controls
    />
    <iframe
      v-else-if="doc.embed_url"
      class="embed"
      :src="doc.embed_url"
      frameborder="0"
      title="DocPreview"
    />
    <div v-else class="embed embed-fallback">
      <span>📄</span>
    </div>
    <div class="meta">
      <div class="mtxt">
        <b>{{ doc.name }}</b>
        <span>{{ doc.description }}</span>
      </div>
      <a class="opentab" :href="doc.url" target="_blank" rel="noopener">
        Open in new tab ↗
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentCard',
  props: {
    doc: {
      type: Object,
      required: true
    }
  },
  computed: {
    isNativeVideo () {
      return typeof this.doc.embed_url === 'string' && /\.(mp4|webm|ogg|mov)(\?|$)/i.test(this.doc.embed_url)
    }
  }
}
</script>

<style scoped>
.doc {
  border: 1px solid var(--line);
  border-radius: 14px;
  overflow: hidden;
  background: var(--white);
  display: flex;
  flex-direction: column;
}
.embed {
  width: 100%;
  height: 300px;
  border: none;
  display: block;
  background: var(--paper);
}
.embed-fallback {
  display: grid;
  place-items: center;
  font-size: 2.4rem;
}
.meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-top: 1px solid var(--line);
}
.mtxt {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.mtxt b {
  font-size: 0.9rem;
}
.mtxt span {
  font-size: 0.78rem;
  color: var(--ink-soft);
}
.opentab {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--teal-dk);
  text-decoration: none;
  white-space: nowrap;
}
</style>
